import { createAsyncThunk } from "@reduxjs/toolkit";
import articleGroupApi from "@infrastructure/articlegroup-api";
import { getErrorPayload } from "@application/common/helpers/api-helper";
export const getAllArticleGroupAsync = createAsyncThunk('ArticleGroup/GetAll', async (_, { rejectWithValue }) => {
    try {
        const response = await articleGroupApi.getAllArticleGroups();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
